import { createApi, ApiError } from "@mnp/shared";

const API_BASE = import.meta.env.VITE_API_BASE || "";

export const api = createApi({
  baseUrl: `${API_BASE}/api/v1`,
  credentials: "include",
});

export { ApiError };

export function apiUrl(path: string): string {
  return `${API_BASE}/api/v1${path}`;
}

/**
 * Скачивает файл (CSV-отчёт) через `<a download>`-трюк. Использует те же
 * `credentials: include`, что и `api`, чтобы прошёл cookie-сессии админа.
 * Ошибки оборачивает в тот же `ApiError`.
 */
export async function downloadFile(path: string, filename: string): Promise<void> {
  const res = await fetch(`${API_BASE}/api/v1${path}`, { credentials: "include" });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new ApiError(res.status, body);
  }
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
